import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const formatTime = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return `${formatDate(dateString)} ${formatTime(dateString)}`;
};

export const getTimeSince = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffDays > 0) return `${diffDays}d ${diffHours % 24}h ago`;
  if (diffHours > 0) return `${diffHours}h ${diffMins % 60}m ago`;
  return `${diffMins}m ago`;
};

export const getDuration = (startDate, endDate) => {
  if (!startDate || !endDate) return "-";
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffMs = end - start;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMins / 60);

  if (diffHours > 0) return `${diffHours}h ${diffMins % 60}m`;
  return `${diffMins}m`;
};

export const PURPOSE_LABELS = {
  breaker_maintenance: "Breaker Maintenance",
  switching: "Switching",
  inspection: "Inspection",
  testing: "Testing",
  emergency_response: "Emergency Response",
  other: "Other",
};

export const ACTIVITY_LABELS = {
  breaker_maintenance_started: "Breaker Maintenance Started",
  breaker_maintenance_completed: "Breaker Maintenance Completed",
  switching_performed: "Switching Performed",
  equipment_isolated: "Equipment Isolated",
  equipment_returned: "Equipment Returned to Service",
  abnormal_condition: "Abnormal Condition Observed",
  safety_issue: "Safety Issue",
  near_miss: "Near Miss",
  emergency_note: "Emergency Note",
  other: "Other Activity",
};

export const ROLE_LABELS = {
  worker: "Substation Worker",
  crew_leader: "Crew Leader",
  operator: "Area Operator",
  supervisor: "Supervisor",
  admin: "Admin",
};

export const STATUS_COLORS = {
  active: "status-active",
  completed: "status-completed",
  incomplete: "status-incomplete",
};
